export enum LanguageCode {
  en,
  fr,
  nl,
}
